/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetOrganizationsBills200ResponseInnerDetailPayee
 */
export interface GetOrganizationsBills200ResponseInnerDetailPayee {
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'bankCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'bankName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'branchCode': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'branchName': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'accountType': GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'accountNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'accountHolder': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrganizationsBills200ResponseInnerDetailPayee
     */
    'isSaved': boolean;
}

export const GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum = {
    savingsAccount: 'SAVINGS_ACCOUNT',
    currentAccount: 'CURRENT_ACCOUNT',
    depositAccount: 'DEPOSIT_ACCOUNT',
    otherAccount: 'OTHER_ACCOUNT'
} as const;

export type GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum = typeof GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum[keyof typeof GetOrganizationsBills200ResponseInnerDetailPayeeAccountTypeEnum];


